import { format } from 'date-fns'

import { DATE_FORMATS } from 'utils/date'

export type SrqDiagnosticsApiParams = {
  date: string
  timezone: string
}

export type SrqSubmitApiParams = {
  timezone: string
}

/** User IANA timezone, e.g. America/New_York */
export const getSrqTimezone = (): string =>
  Intl.DateTimeFormat().resolvedOptions().timeZone

/** YYYY-MM-DD + IANA timezone for diagnostics GET APIs */
export const getSrqDiagnosticsApiParams = (): SrqDiagnosticsApiParams => ({
  date: format(new Date(), DATE_FORMATS.yearFirst),
  timezone: getSrqTimezone()
})

/** IANA timezone only for quiz submit POST */
export const getSrqSubmitApiParams = (): SrqSubmitApiParams => ({
  timezone: getSrqTimezone()
})
